/* Eznzza · puntos de navegación para carruseles.
   Se agregan solos debajo de los carruseles "Destacados estilo Rhode"
   (.rft-slider), "Contenido flexible" (.center-scale-slider) y "Colección
   destacada" (por ejemplo "Más de esta marca" en la ficha) y "Carrusel de
   colecciones" ("Shop by category", reemplaza los puntos propios del tema): un punto por
   posición, el activo se estira en píldora (mismo estilo que "Shop by category").
   Sirve para carruseles con loop (un punto por tarjeta) y sin loop (un punto
   por cada posición a la que se puede avanzar). */
(function () {
  if (window.__ezDots) return;
  window.__ezDots = true;
  var SELECTOR = 'slider-component.rft-slider, slider-component.center-scale-slider, slider-component.collection-carousel-slider, slider-component.ez-product-news-slider, .section-featured-collection slider-component';

  function realCount(swiper) {
    var idx = {};
    var n = 0;
    swiper.slides.forEach(function (s) {
      if (s.classList.contains('swiper-slide-duplicate')) return;
      var i = s.getAttribute('data-swiper-slide-index');
      if (i === null) { n++; return; }
      if (!idx[i]) { idx[i] = true; n++; }
    });
    return n;
  }

  /* Fondo oscuro (bordó) debajo de los puntos: puntos crema */
  function isDark(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      var m = getComputedStyle(n).backgroundColor.match(/[\d.]+/g);
      if (!m) continue;
      if (m.length === 4 && parseFloat(m[3]) < 0.5) continue;
      var lum = (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) / 255;
      return lum < 0.45;
    }
    return false;
  }

  function attach(slider, swiper) {
    if (slider.__ezDots) return;
    slider.__ezDots = true;
    var wrap = document.createElement('div');
    wrap.className = 'ez-dots';
    wrap.setAttribute('role', 'tablist');
    wrap.setAttribute('aria-label', 'Navegación del carrusel');
    slider.insertAdjacentElement('afterend', wrap);
    /* Si la sección traía sus propios puntos, se ocultan: quedan solo los nuestros */
    var sec = slider.closest('.shopify-section') || slider.parentElement;
    sec.querySelectorAll('.custom-carousel-pagination, .swiper-pagination').forEach(function (p) {
      if (!p.closest('.swiper-slide') && !p.closest('.ez-dots')) p.classList.add('ez-dots-replaced');
    });
    if (isDark(wrap)) wrap.classList.add('ez-dots--light');
    var loop = !!(swiper.params && swiper.params.loop);
    var current = -1;

    function count() { return loop ? realCount(swiper) : swiper.snapGrid.length; }
    function active() {
      var n = count();
      var a = loop ? swiper.realIndex : swiper.snapIndex;
      if (!loop && swiper.isEnd) a = n - 1;
      return Math.max(0, Math.min(n - 1, a || 0));
    }

    function build() {
      var n = count();
      wrap.innerHTML = '';
      wrap.hidden = n <= 1;
      current = -1;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ez-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        b.dataset.index = i;
        wrap.appendChild(b);
      }
      update();
    }
    /* Solo cambia el punto activo cuando de verdad cambió (sin parpadeos) */
    function update() {
      var a = active();
      if (a === current) return;
      current = a;
      wrap.querySelectorAll('.ez-dot').forEach(function (b, i) {
        var on = i === a;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function sync() { update(); requestAnimationFrame(update); }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.ez-dot');
      if (!b) return;
      var i = parseInt(b.dataset.index, 10);
      if (loop) swiper.slideToLoop(i);
      else swiper.slideTo(Math.min(i * (swiper.params.slidesPerGroup || 1), swiper.slides.length - 1));
    });
    build();
    ['slideChange', 'realIndexChange', 'snapIndexChange', 'slideChangeTransitionStart', 'transitionEnd', 'reachEnd', 'reachBeginning'].forEach(function (ev) {
      swiper.on(ev, sync);
    });
    swiper.on('snapGridLengthChange', build);
    swiper.on('breakpoint', function () { setTimeout(build, 0); });
    swiper.on('resize', function () { if (wrap.children.length !== count()) build(); else sync(); });
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (slider) {
      if (slider.__ezDotsWait) return;
      slider.__ezDotsWait = true;
      var tries = 0;
      (function wait() {
        if (slider.swiper) attach(slider, slider.swiper);
        else if (tries++ < 100) setTimeout(wait, 100);
      })();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Editor de temas: secciones que se recargan */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Eznzza · Badge "Entrega inmediata" / "Pre-Order" en las tarjetas de
   "Completá tu rutina": se actualiza al elegir otro tono o tamaño. */
(function () {
  if (window.__cyrBadge) return;
  window.__cyrBadge = true;
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-cyr-select]');
    if (!s) return;
    var c = s.closest('[data-cyr-card], .cyr-card');
    var b = c && c.querySelector('[data-cyr-badge]');
    if (!b) return;
    var o = s.options[s.selectedIndex];
    var st = o ? o.getAttribute('data-st') : '';
    b.textContent = st === 'pre' ? b.getAttribute('data-pre') : 'Entrega inmediata';
    b.style.display = st === 'pre' ? 'inline-flex' : 'none';
  });
})();
